import React, { useState, useEffect,useRef} from 'react';
import { useLocation } from 'react-router-dom';
import AdminSidebarNavigation from '../../components/ui/AdminSidebarNavigation';
import AdminHeaderNavigation from '../../components/ui/AdminHeaderNavigation';
import { useAuth } from '../../components/context/AuthContext';
import repositoryContainer from '../../services/RepositoryContainer';
import IdentityHub from './components/IdentityHub';
import ClientExperienceSuite from './components/ClientExperienceSuite';
import LogicSchedulingEngine from './components//LogicSchedulingEngine';
import BillingHub from './components/BillingSection';
import './styles.css';
import Modal from '../../components/ui/Modal';
import Button from '../../components/ui/Button';
import{useToast} from '../../components/context/ToastContext';
import Icon from '../../components/AppIcon';


const Settings = () => {
  const { user, setUser,logout } = useAuth();
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
    const [isCountingDown, setIsCountingDown] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [isArchiving, setIsArchiving] = useState(false);
  const timerRef = useRef(null);
  const { addToast } = useToast();

  // Show success toast when redirected back from subscription payment
  useEffect(() => {
    if (location.state?.subscriptionSuccess) {
      addToast('Your subscription has been upgraded successfully!', 'success');
      // Clear the state so a refresh doesn't re-trigger the toast
      window.history.replaceState({}, '');
    }
  }, []);

  useEffect(() => {
    if (isCountingDown && countdown > 0) {
      timerRef.current = setTimeout(() => setCountdown((c) => c - 1), 1000);
    } else if (isCountingDown && countdown === 0) {
      executeArchiveBusiness();
    }
    return () => clearTimeout(timerRef.current);
  }, [isCountingDown, countdown]);

  const startCountdown = () => {
    setCountdown(10);
    setIsCountingDown(true);
  };

  const cancelCountdown = () => {
    setIsCountingDown(false);
    clearTimeout(timerRef.current);
    setCountdown(10);
  };

  const executeArchiveBusiness = async () => {
    setIsCountingDown(false);
    setIsArchiving(true);
    try {
      await repositoryContainer.company.closeBusiness(); 
      
      
      if (logout) {
        logout();
      } else {
        window.location.href = '/admin/auth';
      }
    } catch (error) {
      console.error('Failed to archive business:', error);
      setIsArchiving(false);
      addToast('Failed to archive business. Please try again.', 'error');
    }
  };

  const handleCloseModal = () => {
    if (isCountingDown || isArchiving) return; 
    setIsCloseModalOpen(false);
  };


    const [isRestoring, setIsRestoring] = useState(false);

  const handleRestore = async () => {
    setIsRestoring(true);
    try {
      await repositoryContainer.company.restoreBusiness();
      // Force a reload to refresh the user context and token from the backend
      window.location.reload(); 
    } catch (err) {
      console.error('Failed to restore business:', err);
      alert('Could not restore the business. Please contact support.');
      setIsRestoring(false);
    }
  };

if (user?.company && user.company.isActive === false) {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;700&display=swap');

        .archive-container {
          font-family: 'DM Sans', sans-serif;
          color: #fff;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
          position: relative;
          background: #000;
        }

        .bg-overlay {
          position: absolute;
          inset: 0;
          background-image: url('https://weyyfslmfqjlkvtfwunm.supabase.co/storage/v1/object/public/Claw/Herosection/heroImage.png');
          background-size: cover;
          background-position: center;
          filter: blur(15px) brightness(0.4);
          opacity: 0.6;
          z-index: 0;
        }

        .archive-card {
          position: relative;
          z-index: 10;
          width: 100%;
          max-width: 480px;
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 24px;
          padding: 48px 32px;
          text-align: center;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        }

        .status-icon-wrap {
          width: 80px;
          height: 80px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .archive-badge {
          display: inline-block;
          padding: 4px 12px;
          background: rgba(234, 179, 8, 0.1);
          border: 1px solid rgba(234, 179, 8, 0.3);
          color: #eab308;
          border-radius: 99px;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 20px;
        }

        .archive-title {
          font-family: 'DM Serif Display', serif;
          font-size: 32px;
          margin-bottom: 12px;
          letter-spacing: -0.02em;
        }

        .archive-desc {
          font-size: 15px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 1.6;
          margin-bottom: 32px;
          font-weight: 300;
        }

        .info-row {
          background: rgba(255, 255, 255, 0.03);
          border-radius: 12px;
          padding: 16px;
          text-align: left;
          margin-bottom: 32px;
          border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .info-item {
          display: flex;
          gap: 12px;
          font-size: 13px;
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 8px;
        }

        .restore-btn {
          width: 100%;
          background: #fff;
          color: #000;
          border: none;
          padding: 16px;
          border-radius: 12px;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s;
          margin-bottom: 12px;
        }

        .restore-btn:hover {
          background: rgba(255, 255, 255, 0.9);
          transform: translateY(-2px);
        }

        .signout-btn {
          width: 100%;
          background: transparent;
          color: rgba(255, 255, 255, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 16px;
          border-radius: 12px;
          font-weight: 500;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .signout-btn:hover {
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
        }
      `}</style>

      <div className="archive-container">
        <div className="bg-overlay" />
        
        <div className="archive-card">
          <div className="status-icon-wrap">
            <Icon name="Archive" size={32} color="rgba(255,255,255,0.7)" />
          </div>

          <div className="archive-badge">Status: Archived</div>
          
          <h1 className="archive-title">Workspace Offline</h1>
          <p className="archive-desc">
            Your business profile for <strong>{user?.company?.name || 'your store'}</strong> has been deactivated. All public booking services and dashboard tools are currently restricted.
          </p>

          <div className="info-row">
            <div className="info-item">
              <Icon name="EyeOff" size={16} color="#eab308" />
              <span>Public booking page is hidden</span>
            </div>
            <div className="info-item">
              <Icon name="Database" size={16} color="#eab308" />
              <span>Data is preserved for compliance</span>
            </div>
            <div className="info-item">
              <Icon name="HelpCircle" size={16} color="#eab308" />
              <span>Contact support@clawappz.com</span>
            </div>
          </div>

          <button className="restore-btn" onClick={handleRestore} disabled={isRestoring}>
            {isRestoring ? 'Processing Restoration...' : 'Reactivate Business'}
          </button>
          
          <button className="signout-btn" onClick={logout}>
            Log Out
          </button>
        </div>
      </div>
    </>
  );
}


  return (
    <div className="flex h-screen bg-[var(--color-background)] overflow-hidden">
      <AdminSidebarNavigation isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
      <div className={`transition-all duration-250 ${isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}></div>
      <div className="flex-1 flex flex-col overflow-hidden">
        <AdminHeaderNavigation title="Business Settings" isSidebarCollapsed={isSidebarCollapsed} />
        
        <main className="flex-1 overflow-y-auto custom-scrollbar">
          <div className="settings-container">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start mt-16 ">
              
              {/* BRANDING & SOCIALS (Full Width Top) */}
              <div className="lg:col-span-12 animate-settings-fade" style={{ animationDelay: '0.1s' }}>
                <IdentityHub companyData={user?.company} setCompanyData={(update) => {
                  // This handles the functional update from IdentityHub
                  setUser(prev => {
                    const newCompany = typeof update === 'function' ? update(prev.company) : update;
                    return {
                      ...prev,
                      company: { ...prev.company, ...newCompany }
                    };
                  });
                }} />
              </div>

              {/* CLIENT POLICIES (Main Left) */}
              <div className="lg:col-span-8 animate-settings-fade" style={{ animationDelay: '0.2s' }}>
                <ClientExperienceSuite companyData={user?.company} setCompanyData={(update)=>{
                  setUser(prev => {
                    const newCompany = typeof update === 'function' ? update(prev.company) : update;
                    return {
                      ...prev,
                      company: { ...prev.company, ...newCompany }
                    };
                  });
                }} />
              </div>

              {/* SCHEDULING LOGIC (Sidebar Right) */}
              <div className="lg:col-span-4 animate-settings-fade" style={{ animationDelay: '0.3s' }}>
                <LogicSchedulingEngine />
              </div>

              {/* BILLING & PAYMENTS (Full Width Bottom) */}
              <div className="lg:col-span-12 animate-settings-fade" style={{ animationDelay: '0.4s' }}>
                <BillingHub />
              </div>
                <div className="lg:col-span-12 flex justify-center py-10">
                  <button 
                    onClick={() => setIsCloseModalOpen(true)}
                    className="text-xs text-destructive hover:text-red-700 font-medium underline underline-offset-4 transition-colors"
                  >
                    Close this Business
                  </button>
                </div>                   

            </div>
          </div>
        </main>
      </div>
      {/* CLOSE BUSINESS MODAL */}
      <Modal 
        isOpen={isCloseModalOpen} 
        onClose={handleCloseModal}
        title={isCountingDown ? "Archiving Business..." : "Close this Business"}
      >
        <div className="space-y-6">
          {!isCountingDown && !isArchiving ? (
            // ─── INITIAL WARNING VIEW ───
            <>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Closing your business will immediately take your store offline. Your clients will no longer be able to view your catalogue or make new bookings.
              </p>

              <div className="bg-destructive/10 border border-destructive/20 p-4 rounded-lg space-y-2">
                <h4 className="text-sm font-bold text-destructive flex items-center gap-2">
                  What happens next
                </h4>
                <ul className="text-sm text-destructive/80 list-disc list-inside space-y-1 ml-1">
                  <li>Your public page will be disabled.</li>
                  <li>Data is securely archived for compliance purposes.</li>
                  <li>You can request to restore your store at any time.</li>
                </ul>
              </div>

              <p className="text-xs text-muted-foreground">
                Need help? Contact <a href="mailto:support@clawappz.com" className="text-foreground hover:underline">support@clawappz.com</a>
              </p>

              <div className="flex justify-end gap-3 pt-6 border-t border-border">
                <Button 
                  variant="ghost" 
                  onClick={handleCloseModal}
                >
                  Cancel
                </Button>
                <Button 
                  variant="destructive" 
                  onClick={startCountdown}
                >
                  Close Business
                </Button>
              </div>
            </>
          ) : (
            // ─── COUNTDOWN & LOADING VIEW ───
            <div className="flex flex-col items-center justify-center py-8 space-y-6 text-center">
              {isArchiving ? (
                <>
                  <div className="w-12 h-12 border-4 border-destructive border-t-transparent rounded-full animate-spin mx-auto" />
                  <p className="text-lg font-bold text-foreground">Archiving...</p>
                  <p className="text-sm text-muted-foreground">Logging you out shortly.</p>
                </>
              ) : (
                <>
                  <div className="text-7xl font-heading font-bold text-destructive animate-pulse">
                    {countdown}
                  </div>
                  <p className="text-sm text-muted-foreground font-medium">
                    Archival sequence initiated. You have a few seconds to cancel.
                  </p>
                  <div className="pt-4 w-full">
                    <Button 
                      variant="outline" 
                      className="w-full"
                      onClick={cancelCountdown}
                    >
                      Cancel Archival
                    </Button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </Modal>
      <div/>
    </div>
  );
};

export default Settings;
